export default "__VITE_ASSET__0LI0CMKQ__"